module.exports = __webpack_public_path__ + "static/media/other-irregular-income.de608e65.svg";